import { model } from '@modern-js/runtime/model';
import { Message } from '@arco-design/web-react';
import { fetchUserLogOut } from '@api/copilot_api';
import { UserInfo } from '@hkgai/pb-fe-api/lib/interface/copilot_api';
// import { Sidebars, SidebarStatus } from '@/type/copilot';

interface ExtendedUserInfo extends UserInfo {
  meetingOnlyUser?: number;
}

interface Props {
  userInfo: ExtendedUserInfo;
}

const GlobalStore = model<Props>('GlobalStore').define({
  state: {
    userInfo: {},
    resources: [],
    uploadFiles: [],
    selectUploadFiles: [],
  },
  actions: {
    setUser(draft, data) {
      draft.userInfo = data;
    },
    //  user login out
    onLogOut: {
      pending(draft) {
        console.log(draft);
      },
      fulfilled(draft, data) {
        console.log(draft, data);
      },
      rejected(draft, error) {
        Message.error(`code: ${error.code}, msg:${error.msg}` || '操作失败，请稍后再试');
        console.log(draft, error);
      },
    },
  },
  computed: {},
  effects: {
    async onLogOut(callbacks?: VoidFunction) {
      const data = await fetchUserLogOut({});
      callbacks?.();
      return data;
    },
  },
});

export default GlobalStore;
